import shard1 from "./shards/shard1";
import shard2 from "./shards/shard2";
import shard3 from "./shards/shard3";
import shard4 from "./shards/shard4";
import shard5 from "./shards/shard5";
import shard6 from "./shards/shard6";
import shard7 from "./shards/shard7";

// Fixed, non-page-specific strings that live inside the shared
// src/components/ui/* components (status words, chart/legend labels,
// button text). Kept here rather than in a page shard since these are
// reused across every page that renders the component.
const COMPONENT_STRINGS = {
  // StatusBadge / generic status words
  "Active": "सक्रिय", "Resolved": "निकाली", "Approved": "मंजूर", "Live": "थेट",
  "Normal": "सामान्य", "Ready": "सज्ज", "Info": "माहिती", "In Progress": "प्रगतीपथावर",
  "Located": "सापडले", "Warning": "सूचना", "Moderate": "मध्यम", "Med": "मध्यम",
  "Near": "जवळ", "Critical": "गंभीर", "High": "उच्च", "Over": "जास्त",
  "Pending": "प्रलंबित", "Closed": "बंद", "Low": "कमी", "Simulated": "सिम्युलेटेड",
  "CRITICAL": "गंभीर", "HIGH": "उच्च", "MED": "मध्यम", "LIVE": "थेट",

  // ProgressWidget bucket labels
  "Normal ": "सामान्य",

  // TimelineCard
  "Owner": "जबाबदार", "SLA": "एसएलए",

  // DepartmentCard
  "deployed": "तैनात", "alerts": "इशारे", "Deployment": "तैनाती", "Resolution Rate": "निराकरण दर",

  // SimulationPanel
  "Est. Crowd": "अंदाजित गर्दी", "Critical Zones": "गंभीर झोन", "Evac. Time": "बाहेर काढण्याचा वेळ",
  "Running Simulation...": "सिम्युलेशन सुरू आहे...", "Run Scenario": "परिस्थिती चालवा",

  // CopilotPanel
  "Location": "स्थान", "Assigned To": "नियुक्त", "Escalation Time": "एस्कलेशन वेळ",
  "Status": "स्थिती", "AI SOP Recommendations": "एआय एसओपी शिफारसी",

  // MapPlaceholder
  "Crowd": "गर्दी", "Heat": "उष्णता", "Zones": "झोन",
  "Godavari River": "गोदावरी नदी",
  "Nashik · Simhastha 2027 — Live GIS View": "नाशिक · सिंहस्थ 2027 — थेट जीआयएस दृश्य",
  "Active pilgrims": "सक्रिय यात्रेकरू", "Risk Level": "जोखीम पातळी",
  "Ramkund Ghat": "रामकुंड घाट", "Panchvati": "पंचवटी", "Trimbakeshwar": "त्र्यंबकेश्वर",
  "Nashik Road Stn": "नाशिक रोड स्थानक", "Kalaram Temple": "काळाराम मंदिर", "Gangapur Camp": "गंगापूर कॅम्प",
  "Main Snan Ghat": "मुख्य स्नान घाट", "Pilgrim Zone": "यात्रेकरू क्षेत्र", "Temple Town": "मंदिर नगरी",
  "Transport Hub": "वाहतूक केंद्र", "Temple Zone": "मंदिर क्षेत्र", "Staging Camp": "तळ छावणी",
  "pilgrims": "यात्रेकरू",

  // AlertTable column headers
  "Time": "वेळ", "Alert": "इशारा", "Department": "विभाग", "Priority": "प्राधान्य",
};

export const TRANSLATIONS = {
  ...COMPONENT_STRINGS,
  ...shard1,
  ...shard2,
  ...shard3,
  ...shard4,
  ...shard5,
  ...shard6,
  ...shard7,
};
